import CompraFab from './CompraFab';

export default CompraFab;
